import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/brand_market/brandWall",
  name: "brand_market_brandWall",
  component: function component() {
    return import("../../../views/brand_market/brandWall");
  },
  meta: {
    title: "品牌墙",
    foot: true
  }
},
// 品牌首页
{
  path: "/brand_market/brand_home/:id?",
  component: function component() {
    return import("../../../views/brand_market/brand_home");
  },
  name: "brand_market_brand_home",
  meta: {
    title: "品牌首页",
    foot: true
  }
},
// 分享海报
{
  path: "/brand_market/cloud_shop_sharePage/:brand_id?/:brand_collect_id?",
  component: function component() {
    return import("../../../views/brand_market/cloud_shop_sharePage.vue");
  },
  name: "brand_market_cloud_shop_sharePage",
  meta: {
    title: "分享",
    foot: true
  }
},
// 品牌素材
{
  path: "/brand_market/brand_source_material/:id?",
  component: function component() {
    return import("../../../views/brand_market/brand_source_material.vue");
  },
  name: "brand_market_brand_source_material",
  meta: {
    title: "品牌素材",
    foot: true
  }
}];